const premium = {
  coupon: {
    placeholder: "Añadir cupón",
    success: {
      title: "¡Éxito!",
      message: "Su cupón ha sido redimido",
    },
    error: {
      title: "¡Uh-oh!",
      message: "Código de Cupón Incorrecto",
    },
    redeem: "Redimir",
    payment_one: "pago",
    payment_other: "{{ count }} pagos",
    coupon_applied: "¡Felicidades! Recibirá un descuento del {{ discount }} en sus primeros {{ duration }}",
    your_subscription: '¡Tiene {{ coupon }} de descuento!',
    discount_will_be_automatically_applied_at_checkout: 'El cupón se aplica automáticamente al seleccionar su plan'
  },
  payment: {
    title: "Pago",
    choose_the_plan: "Seleccione el plan de suscripción que le funcione mejor",
    subtitle: "Ingrese los datos de pago para empezar su suscripción",
    plan_type: "Tipo de plan",
    selected: "Su elección:",
    plan_price: "Costo del plan",
    membership: "Membresía anual SEP+ ",
    annual_membership: "Membresía anual",
    monthly_membership: "Membresía mensual",
    monthly: "Mensual",
    price: "Precio",
    duration: "mes",
    credit_card_number: "Número de tarjeta",
    expiry: "Expiración mm/aa",
    cvv: "CVV",
    confirm_purchase: "Confirmar compra",
    failure_title: "¡Uh-oh!",
    product_name: "Membresía Premium",
    or: "O",
    pay_with_card: "pague con tarjeta",
    update_and_pay: "Actualizar + Pagar",
    yearly: "Anual",
    proceed: "Proceder al pago",
    one_time_discount: 'Cupón de uso único',
    total: 'Total'
  },
  past_due: {
    status_message: "El pago de su suscripción a PODERsalud no pasó. Por favor consulte el saldo de su tarjeta y actualice su método de pago.",
    success_title: "Felicidades",
    success_message: "Su pago se ha procesado correctamente y la información de su tarjeta se ha actualizado.",
  },
  not_available: "Lo sentimos, este producto no está disponible en su estado.",
  update_payment: {
    success_title: "Felicidades",
    // TODO: This is probably wrong.  We don't have copy for this in proton
    success_message: "La información de su tarjeta se ha actualizado.",
  },
  annual: {
    billed_annually: "Un solo cobro <strong>anual</strong>",
    billed_monthly: "Cobro <strong>mensual</strong>",
    discount_percentage: "{{ discount }}% de ahorro",
    months_free: "{{ number }} meses gratis",
    no_discount: "Sin discuento",
    pay_full_price: "Pagar precio regular",
    per_month: "/ mes",
    per_year: "/ año",
  },
  ask_us_anything: {
    title: "Pregúntenos cualquier duda",
    got_questions: "¿Tiene preguntas? ¿Le gustaría saber si PODERsalud es ideal para usted? ¡Con gusto le asistimos!",
    talk_with_an_expert: "Hable con un experto",
  }
};

export default premium;
